import { AuthorizedContent } from 'modules/auth';
import { DeleteItemForm } from 'modules/forms';
import { useI18n } from 'modules/i18n';
import { useProject } from 'modules/routes';
import { Modal } from 'modules/ui';
import { sanitizeHtml } from 'modules/utils';
import PropTypes from 'prop-types';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';

import AnnotationFormContainer from './AnnotationFormContainer';

export default function Annotation({
    annotation,
    contentLocale,
    segment,
    deleteData,
}) {
    const { t, locale } = useI18n();
    const { project, projectId } = useProject();

    return (
        <div className="SegmentAnnotation">
            <span
                dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(
                        annotation.text[contentLocale],
                        'BASIC'
                    ),
                }}
            />
            <AuthorizedContent object={annotation} action="update">
                <span className="flyout-sub-tabs-content-ico">
                    <Modal
                        title={t('edit.annotation.edit')}
                        trigger={
                            <FaPencilAlt className="Icon Icon--editorial Icon--small" />
                        }
                    >
                        {(closeModal) => (
                            <AnnotationFormContainer
                                annotation={annotation}
                                segment={segment}
                                contentLocale={contentLocale}
                                onSubmit={closeModal}
                                onCancel={closeModal}
                                cancelLabel={t('cancel')}
                                submitLabel={t('submit')}
                            />
                        )}
                    </Modal>
                    <Modal
                        title={t('edit.annotation.delete')}
                        trigger={
                            <FaTrash className="Icon Icon--editorial Icon--small" />
                        }
                    >
                        {(closeModal) => (
                            <DeleteItemForm
                                onSubmit={() => {
                                    deleteData(
                                        { locale, projectId, project },
                                        'annotations',
                                        annotation.id,
                                        null,
                                        null,
                                        true
                                    );
                                    closeModal();
                                }}
                                onCancel={closeModal}
                            >
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: sanitizeHtml(
                                            annotation.text[contentLocale],
                                            'BASIC'
                                        ),
                                    }}
                                />
                            </DeleteItemForm>
                        )}
                    </Modal>
                </span>
            </AuthorizedContent>
        </div>
    );
}

Annotation.propTypes = {
    annotation: PropTypes.object.isRequired,
    segment: PropTypes.object.isRequired,
    contentLocale: PropTypes.string.isRequired,
    deleteData: PropTypes.func.isRequired,
};
